import { absoluteUrl, getSeoPage, SeoPage, structuredData } from "./seo";

function meta(attribute: "name" | "property", key: string, value: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = value;
}

export function applySeoHead(pathname: string) {
  const page: SeoPage = getSeoPage(pathname) || {
    path: pathname,
    title: "Pagina nu a fost găsită | AUPPS Personocrația",
    heading: "Pagina nu a fost găsită",
    description: "Pagina căutată nu este disponibilă.",
    noindex: true,
  };
  const canonical = absoluteUrl(page.path);
  document.title = page.title;
  meta("name", "description", page.description);
  meta("name", "robots", page.noindex || process.env.REACT_APP_ENV !== "production" ? "noindex, follow" : "index, follow");
  meta("property", "og:type", page.kind === "article" ? "article" : "website");
  meta("property", "og:site_name", "AUPPS Personocrația");
  meta("property", "og:locale", "ro_RO");
  meta("property", "og:title", page.title);
  meta("property", "og:description", page.description);
  meta("property", "og:url", canonical);
  meta("name", "twitter:card", "summary_large_image");
  meta("name", "twitter:title", page.title);
  meta("name", "twitter:description", page.description);
  if (page.image) {
    meta("property", "og:image", absoluteUrl(page.image));
    meta("name", "twitter:image", absoluteUrl(page.image));
  }
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = canonical;
  document.head.querySelectorAll('script[data-seo-schema="true"]').forEach(element => element.remove());
  for (const item of structuredData(page)) {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.seoSchema = "true";
    script.textContent = JSON.stringify(item).replace(/</g, "\\u003c");
    document.head.appendChild(script);
  }
}
